import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TarifasService } from '../../services/tarifas.service';
import { AuthService } from '../../services/auth.service';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '../../services/localization.service';
import * as moment from 'moment';
import { TarifaDetallesService } from '../../services/tarifa-detalles.service';
import { TarifaDetalleEditComponent } from '../tarifa-detalle-edit/tarifa-detalle-edit.component';
import { TarifaModel } from '../../models/TarifaModel';
import { GlobalUIUtilsService } from '../../services/global-ui-utils.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tarifas-edit',
  templateUrl: './tarifas-edit.component.html',
  styleUrls: ['./tarifas-edit.component.scss']
})
export class TarifasEditComponent implements OnInit {

  tarifa: TarifaModel;
  localization: LocalizationService;
  tarifaForm: FormGroup;
  title: string = "Crear";
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: any;

  tipoContratoList: any;
  tarifaList: any;
  tarifaDetalleList: any;
  options: any = {
    format: 'DD/MM/YYYY'
  };
  dialogConfig: MatDialogConfig;
  message = this.translate.instant('comunes.toastr_guardado');

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, localization: LocalizationService,
    private _TarifasService: TarifasService, private _authService: AuthService, private _router: Router,
    private _location: Location, private _tarifaDetalleService: TarifaDetallesService, private _dialog: MatDialog,
    private _GlobalUIUtilsService: GlobalUIUtilsService, private translate: TranslateService) {

    this.tarifa = new TarifaModel();
    this.localization = localization;

    if (this._avRoute.snapshot.params["id"]) {
      this.id = this._avRoute.snapshot.params["id"];
    }
    else {
      this.id = 0;
    }

    this.tarifaForm = this._fb.group({
      id: 0,
      nombre: ['', Validators.required],
      fechaInicio: ['', Validators.required],
      tipoCalculo: ['', Validators.required],
      fechaFin: [null],
      // importeFijo: [''],
      // porcentaje: [''],
      // max: [''],
      // min: [''],
      activo: [true],
      createdBy: [''],
      updatedBy: [''],
      updatedDate: [''],
      createdDate: [new Date],
      //createdByName: [''],
      //updatedByName: ['']
    });

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = "Editar";

      // this._TarifasService.getTarifaByID(this.id)
      //   .subscribe(resp => {
      //     this.tarifaForm.setValue(resp);
      //     this.disableCheck();
      //   }
      //     , error => {
      //       this.errorMessage = error;
      //       console.log(error);
      //     });
      this._TarifasService.getTarifaByID(this.id)
        .subscribe((resp: TarifaModel) => {
          if (resp == null) {
            this._router.navigate(['/tarifas']);
          }
          this.tarifa = resp;
          this.tarifaForm.setValue(resp);
          this.disableCheck();
        }, error => {
          this.errorMessage = error;
          console.log(error);
        })

      this.getDataDetalle();
    }
    else {
      this.isNewElement = true;
      this.disableCheck();
    }
  }

  getDataDetalle() {
    this._tarifaDetalleService.getTarifaByTarifaId(this.id)
      .subscribe((data: any) => {
        if (data.estado == "Error") {
          this.tarifaDetalleList = null;
        }
        else {
          this.tarifaDetalleList = data;
        }
      }
        , error => {
          this.errorMessage = error;
          console.log(error);
        });
  }

  disableCheck() {
    if (this.tarifaForm.get('tipoCalculo').value == 1) {
      this.tarifaForm.get('importeFijo').enable();
      this.tarifaForm.get('porcentaje').disable();
      this.tarifaForm.get('max').disable();
      this.tarifaForm.get('min').disable();
    }
    else {
      this.tarifaForm.get('importeFijo').disable();
      this.tarifaForm.get('porcentaje').enable();
      this.tarifaForm.get('max').enable();
      this.tarifaForm.get('min').enable();
    }
  }

  public moment(data) {
    if (data == null || data == "") {
      return null;
    }
    return moment.utc(data).local().format('DD/MM/YYYY')
  }

  cancel() {
    this._location.back();
  }

  save() {
    if (!this.tarifaForm.valid) {
      return;
    }

    if (this.isNewElement) {
      this._TarifasService.createTarifa(this.tarifaForm.value)
        .subscribe((data) => {
          this._location.back();
          this._GlobalUIUtilsService.success(this.message);
        }, error => this.errorMessage = error)
    }
    else {
      this._TarifasService.updateTarifa(this.tarifaForm.value)
        .subscribe((data) => {
          this._location.back();
          this._GlobalUIUtilsService.success(this.message);
        }, error => this.errorMessage = error)
    }
  }

  delete(id) {
    this._tarifaDetalleService.deleteTarifaDetalle(id).subscribe(data => {
      this.getData();
    });
  }

  public newItem() {
    const ref = this._dialog.open(TarifaDetalleEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.componentInstance.tarifaId = this.id;
    ref.afterClosed().subscribe(result => {
      this.getDataDetalle();
    });
  }

  public editItem(id:number) {
    let dlgRef = this._dialog.open(TarifaDetalleEditComponent, this.dialogConfig);
    dlgRef.componentInstance.id = id;
    dlgRef.componentInstance.tarifaId = this.id;
    dlgRef.componentInstance.isModal = true;
    dlgRef.afterClosed().subscribe(result => {
      this.getDataDetalle();
    });
  }

  get nombre() { return this.tarifaForm.get('nombre'); }
  get fechaInicio() { return this.tarifaForm.get('fechaInicio'); }
  get tipoCalculo() { return this.tarifaForm.get('tipoCalculo'); }
}
